<template>
    <rkm-area
        title="Procedimentos compatíveis"
        type="fieldset"
    >
        <rkm-form ref="Form">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="procedimentosSecundarios"
                        :validations="validations.procedimento"
                        label="Procedimento"
                        show-default-option
                        text-field="descricao"
                        v-model="model.procedimentoCodigo"
                        value-field="codigo"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            hide-filters
            :items="data.model.procedimentosSecundarios"
            :fields="fields"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="toggleAtivo(item)"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    :disabled="item.hasVinculos"
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                procedimento: { required: true }
            }
        },
        procedimentosSecundarios() {

            return this.data.form.procedimentosSecundarios.filter(procedimento =>
                !this.data.model.procedimentosSecundarios.find(p => p.procedimentoCodigo === procedimento.codigo))
        },
    },
    data: () => ({
        model: {
            procedimentoCodigo: null,
            ativo: true,
            hasVinculos: false
        },
        fields: [
            { key: 'procedimentoDescricao', label: 'Procedimento', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' }
        ]
    }),
    methods: {
        add() {

            const data = this.clone(this.model)

            data.procedimentoDescricao = this.data.form.procedimentosSecundarios
                .find(p => p.codigo === data.procedimentoCodigo).descricao

            this.data.model.procedimentosSecundarios.push(data)

            this.resetForm()
        },
        resetForm() {

            this.model.procedimentoCodigo = null
            this.model.ativo = true
            this.model.hasVinculos = false

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        toggleAtivo(item) {

            if (item.ativo && this.data.form.procedimentosSecundarios.find(p => p.codigo === item.procedimentoCodigo)) {

                this.showAttentionConfirmation(
                    'Este procedimento permanece vinculado à OCI no SIGTAP da competência atual. Confirma sua desativação no cadastro?',
                    async () => item.ativo = false
                )

                return
            }

            item.ativo = !item.ativo
        },
        handleDestroy(procedimentoSecundario) {

            const destroy = async () => {

                this.data.model.procedimentosSecundarios
                    .splice(this.data.model.procedimentosSecundarios.indexOf(procedimentoSecundario), 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento secundário?', destroy)
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true }
    }
}
</script>